import VueI18n from "vue-i18n";
import Vue from "vue";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from "@/shared/scripts/helpers/constants/trans";
import english from "@/shared/lang/en.json";
import routesen from "@/shared/lang/routes-en.json";

Vue.use(VueI18n);

const en = Object.assign(english,routesen);

export const i18n = new VueI18n({
    locale: DEFAULT_LANGUAGE, // set locale
    fallbackLocale: FALLBACK_LANGUAGE,
    messages: { en: en }, // set locale messages
    silentTranslationWarn: true
});